export const checkbox = {
  colorScheme: {
    light: {
      background: '#F4F7FE',
      checked: {
        background: '#4318FF',
        hover: {
          background: '#4318FF'
        }
      },
      border: {
        color: '#4318FF'
      }
    },
    dark: {
      background: 'red',
      checked: {
        background: '#4318FF',
        hover: {
          background: '#4318FF'
        }
      },
      border: {
        color: '#4318FF'
      }
    }
  }


}
